/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import CreateStatus from 'astro/server/status/create.status';
import UpgradeStatus from 'astro/server/status/upgrade.status';
import DefaultStatus from 'astro/server/status/default.status';
import DisbandStatus from 'astro/server/status/disband.status';

import SetupStatus from 'astro/server/status/setup.status';
import ActiveStatus from 'astro/server/status/active.status';
import CooldownStatus from 'astro/server/status/cooldown.status';


export default (status, parent) =>
{
  if (status != null)
  {
    switch (status.type)
    {
      case 'create':   return new CreateStatus(status, parent);
      case 'upgrade':  return new UpgradeStatus(status, parent);
      case 'default':  return new DefaultStatus(status, parent);
      case 'disband':  return new DisbandStatus(status, parent);

      case 'setup':    return new SetupStatus(status, parent);
      case 'active':   return new ActiveStatus(status, parent);
      case 'cooldown': return new CooldownStatus(status, parent);
    }
  }

  throw new Error('Unsupported status type.');
}
